import React from 'react'
import { connect } from 'react-redux'
import { FormGroup, Label, Table } from 'reactstrap'
import LoadedInvoiceProduct from './LoadedInvoiceProduct'

export const LoadedInvoiceDetails = (props) => {
  if (props.loadedInvoice && props.loadedInvoice.invoiceFound) {
    return (
      <React.Fragment>
        <FormGroup row>
          <Label for="InvoiceNumber" sm={6} size="lg">
            Invoice Products for #{props.loadedInvoice.invoiceNumber}
          </Label>
          <Table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Re-Upload User CSV</th>
                <th>Existing Upload</th>
              </tr>
            </thead>
            {props.loadedInvoice.cwInvoiceProducts && props.loadedInvoice.cwInvoiceProducts.length > 0 ? (
              <tbody>
                {props.loadedInvoice.cwInvoiceProducts.map((product, index) => (
                  <LoadedInvoiceProduct index={index} key={index} product={product} />
                ))}
              </tbody>
            ) : (
              <tbody>
                <td colSpan="6" style={{ textAlign: 'center', fontSize: '1.25rem' }}>
                  No Reconciliations for this invoice were found
                </td>
              </tbody>
            )}
          </Table>
        </FormGroup>
      </React.Fragment>
    )
  } else if (props.loadedInvoice && props.loadedInvoice.invoiceFound === false) {
    return (
      <FormGroup row>
        <Label for="invoiceError" sm={6} size="lg">
          Invoice not found, invoice must not be closed.
        </Label>
      </FormGroup>
    )
  } else {
    return (
      <FormGroup row>
        <Label for="invoiceError" sm={6} size="lg">
          Sorry, something went wrong
        </Label>
      </FormGroup>
    )
  }
}

const mapStateToProps = (state) => ({
  loadedInvoice: state.recon.loadedInvoice,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(LoadedInvoiceDetails)
